import { useWorkDocumentDetail } from "@/lib/workDocumentQueries";
import { useBlockPresence } from "@/hooks/useBlockPresence";
import RoomBlockField from "./RoomBlockField";

/**
 * Master v5 Prompt 9 — fetches the InteractionInstance's companion
 * WorkDocument and renders each of its blocks through RoomBlockField.
 * Shared by the three block-based renderers (Guided Practice,
 * Reflection, Checklist) — each renderer only differs in title/framing
 * copy around this list, never in the underlying block engine.
 */
export default function BlockList({ workspaceId, docId, isViewAsClient, isInstanceLocked }) {
  const { data, isPending, isError } = useWorkDocumentDetail(workspaceId, docId);
  useBlockPresence({ workspaceId, docId, enabled: !!data && !isError });

  if (isError) {
    return <p className="text-terracotta text-sm" data-testid="room-block-list-error">This exercise's content could not be loaded.</p>;
  }
  if (isPending || !data) {
    return <p className="text-ink-soft text-sm" data-testid="room-block-list-loading">Loading…</p>;
  }

  const blocks = data.blocks || [];
  return (
    <div className="space-y-3" data-testid="room-block-list">
      {blocks.map((b) => (
        <RoomBlockField
          key={b.block_id}
          workspaceId={workspaceId}
          docId={docId}
          block={b}
          isViewAsClient={isViewAsClient}
          isInstanceLocked={isInstanceLocked}
        />
      ))}
      {blocks.length === 0 && <p className="text-ink-soft text-sm" data-testid="room-block-list-empty">No sections yet.</p>}
    </div>
  );
}
